export const matchesDestinationFilter = (destinations, currentDestinationLabels = []) => {
	if (!Array.isArray(destinations) || destinations.length === 0) {
		return true;
	}
	if (!Array.isArray(currentDestinationLabels)) {
		return false;
	}
	return currentDestinationLabels.some(label => label && destinations.includes(label));
};
